export default __webpack_public_path__ + "static/brilliantly-warm-banner-4cc3501d0660ec05cdc955dde62f1617.webp";